import { PageBase } from "./PageBase";

export{
    PageBase
}